<template>
  <div class="text-center">
    <a href="#" @click="goToSinisterFile(sinister_id)">
      {{ sinister_number }}
    </a>
  </div>
</template>

<script>
export default {

  name: 'sinisterDetailR',

  props: {
    sinister_number: [String],
    sinister_id: [Number]
  },
  methods: {
    goToSinisterFile(id) {
      const routeData = this.$router.resolve({
        name: 'Ficha de Siniestro Carretero',
        params: {
          id
        },
      })

      window.open(routeData.href, '_blank')
    }
  },

  data() {
    return {

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Reports/BudgetReport/SinisterDetail.vue